import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'menuDispMapRange',
  standalone: false,
})
export class MenuDispMapRangePipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.MENU_DISP_MAP_RANGE_NONE:
        type = this.translate.instant('常に表示');
        break;
      case AppConst.MENU_DISP_MAP_RANGE_200:
        type = this.translate.instant('半径200m以内表示');
        break;
      case AppConst.MENU_DISP_MAP_RANGE_500:
        type = this.translate.instant('半径500m以内表示');
        break;
      case AppConst.MENU_DISP_MAP_RANGE_1000:
        type = this.translate.instant('半径1000m以内表示');
        break;
    }
    return type;
  }

}
